module.exports = __webpack_public_path__ + "homepage/img/login-success-banner.8dbf6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/homeIndex/login-success-banner.png
// module id = EZZh
// module chunks = 12